import React from 'react';
import Head from 'next/head';
import { ThemeType } from 'types/publishedAssets';
import { buildThemeCss, customFontFamilies } from './buildThemeCss';

interface ThemeProps {
  theme?: ThemeType;
}

export function Theme(props: ThemeProps) {
  const { theme } = props;

  return (
    <>
      {/* Google Fonts stylesheets belong in the body: from the head they block
          first paint on a round trip, and the font stack already covers the wait
          with Inter and its metric-adjusted fallback. */}
      {customFontFamilies(theme).map((family) => (
        <link
          key={family}
          href={`https://fonts.googleapis.com/css?family=${family}:400,500,600,700,800`}
          rel="stylesheet"
        />
      ))}
      {/* The brand stylesheet goes in the head so its variables are parsed before
          first paint. Inject as raw HTML: React entity-escapes text children during
          SSR, but browsers never decode entities inside <style>, which both breaks
          the quoted font-family values and causes a hydration text mismatch. */}
      <Head>
        {/* eslint-disable-next-line react/no-danger */}
        <style key="theme-style" dangerouslySetInnerHTML={{ __html: buildThemeCss(theme) }} />
      </Head>
    </>
  );
}
